import React from 'react';
import {useTranslation} from 'react-i18next';

import {Text, SvgImage, FontVariant} from '@pexip/components';

import styles from './CallHistoryEmpty.module.scss';

import boxes from '../../assets/images/boxes.svg';

export const CallHistoryEmpty: React.FC<{
    type: 'recents' | 'favorites';
}> = ({type}) => {
    const {t} = useTranslation();
    const message =
        type === 'recents'
            ? t(
                  'media.call-history.you-have-no-recents-title',
                  'You have no recents',
              )
            : t(
                  'media.call-history.you-have-no-favorites-title',
                  'You have no favorites',
              );

    return (
        <div className={styles.container}>
            <SvgImage className={styles.boxes} source={boxes} />
            <Text htmlTag="p" className="mb-2" fontVariant={FontVariant.H5}>
                {message}
            </Text>
        </div>
    );
};
